import type { FetchProductQuery } from '@eliadmin/core/src/api/products/product-api';
import type { ImageType } from '@eliadmin/core/src/api/api-types';

export type FinderCategory = {
  id: number | string;
  name: string;
  slug: string;
  image?: ImageType | null;
};
export const TONER_SCOPE_SLUGS = ['kompatibilne-tonery', 'originalne-tonery', 'renovovane-tonery'];

export function printerHref(slug: string, scope?: string | null, brandSlug?: string) {
  const params = new URLSearchParams();
  if (scope && TONER_SCOPE_SLUGS.includes(scope) && scope !== slug) params.set('typ', scope);
  if (brandSlug && brandSlug !== slug) params.set('znacka', brandSlug);
  return `/${slug}${params.size ? `?${params}` : ''}`;
}

/** A model and a toner type must BOTH match; putting them in one `in` would be OR. */
export function withTonerScope(
  query: FetchProductQuery,
  scopeId?: number | string,
): FetchProductQuery {
  if (!scopeId) return query;
  const scope = { categoriesId: { in: [Number(scopeId)] } };
  return { ...query, where: query.where ? { and: [query.where, scope] } : scope };
}

/** Swap only the base listing relation, retaining the core's attribute, price and sorting query. */
export function withListingSource(
  query: FetchProductQuery,
  id: number,
  source: 'category' | 'manufacturer' = 'category',
): FetchProductQuery {
  if (source === 'category') return query;
  const where = withoutCategoryRelation(query.where ?? {});
  const manufacturer = { manufacturers: { in: [id] } };
  return {
    ...query,
    where: Object.keys(where).length ? { and: [manufacturer, where] } : manufacturer,
  };
}

/** Core attribute filters wrap the base relation in AND groups. Strip it at every level. */
function withoutCategoryRelation(
  condition: NonNullable<FetchProductQuery['where']>,
): NonNullable<FetchProductQuery['where']> {
  const where = { ...condition };
  delete where.categoriesId;
  if (where.and) {
    where.and = where.and.map(withoutCategoryRelation).filter(item => Object.keys(item).length);
    if (!where.and.length) delete where.and;
  }
  return where;
}
